import * as React from "react"

import { buildView } from "../../../components/builder/templates/view-model"
import QuoteForm from "../../../components/builder/templates/QuoteForm"
import TemplateFromDocument from "../../runtime/Template"
import document from "./document.json"
import { TEMPLATE_ID } from "./config/template-id"
import "./overrides.css"

/**
 * Valley Roofing — composed in the Template Maker, installed by WTM-022.
 *
 * The design is `document.json`; the renderer is shared with every other
 * composed template. Nothing here is hand-written per design, which is what
 * lets a new one be an install rather than a port.
 */
const entry = {
  id: TEMPLATE_ID,
  worth: 80000,
  label: "Valley Roofing",
  blurb: "Composed in the Template Maker from 10 sections.",
  premium: true,
  from: "library/template-3",
  ported: true,
  /**
   * A ported template is handed the draft and builds its own view, exactly as
   * the built-in designs do — so this one reads the contractor's answers
   * through the same function they do rather than a parallel path that could
   * disagree with them.
   */
  Component: ({ draft, plan, mode }) => (
    // `quoteForm` is FCS's own lead form: the hero's form is a real one that submits, and is drawn only on the Lead Generation plan.
    <TemplateFromDocument document={document} view={buildView(draft, { plan, mode })} quoteForm={QuoteForm} />
  ),
}

export default entry
